import Table from "../elements/table";
import { useState, useEffect } from "react";
import Dashboard_Loader from "../navigation/dashboard_loader";
import { getAuth, onAuthStateChanged } from "../../../../globals/backend/authClient";
import { getTickets } from "../../../../globals/backend/ticketsApi";

function Ticket_Archivio({ navOpened }) {
    const [showLoader, setShowLoader] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);

    const auth = getAuth();
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setIsAdmin(!!user && user.email.includes('admin@auth.com'));
        });
        return () => unsubscribe();
    }, [auth]);

    const Choices1 = [
        {
            icon: '❗️',
            description: 'Urgente'
        },
        {
            icon: '⚠️',
            description: 'Importante'
        },
        {
            icon: '✅',
            description: 'Normale'
        }
    ];

    const Choices2 = [
        {
            icon: '💻',
            description: 'Software'
        },
        {
            icon: '🔧',
            description: 'Hardware'
        }
    ];

    const Choices3 = [
        {
            icon: '⏺',
            description: 'Ricevuto'
        },
        {
            icon: '🔁',
            description: 'In Corso'
        },
        {
            icon: '⏹',
            description: 'Concluso'
        }
    ];


    const [tickets, setTickets] = useState([]);
    const fetchTickets = async () => {
        setShowLoader(true);
        try {
            const data = await getTickets({ statoEq: 2 });
            setTickets(data);
        } catch (error) {
            console.error('Errore nella richiesta al server:', error);
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 800);
        }
    };

    useEffect(() => {
        fetchTickets();
    }, []);

    return (
        <>
            <div className={`Ticket_InCorso_MainDiv ${navOpened ? "padding-leftTickets" : ""}`}>
                {true && <Table navOpened={navOpened} requireDataHandler={() => fetchTickets()} isAdmin={isAdmin} GeneralData={tickets} Choices1Data={Choices1} Choices1Text="Priorità" Choices2Data={Choices2} Choices2Text="Tipo" Choices3Data={Choices3} Choices3Text="Stato" />}
            </div>
            {showLoader && <Dashboard_Loader />}
        </>
    );
};

export default Ticket_Archivio;
